import { dataFileErrorSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileErrorSolid = /*#__PURE__*/createIcon(dataFileErrorSolid)
export default IconFileErrorSolid
